import Stripe from 'stripe';
import { OvTableData } from '../../../components/UI/molecules/OvTable';
import i18n from '../../../i18n/config';
import { ShippingRate } from '../../model/dto/shipping-rate/shipping-rate';
import { TableRowEditWidgetType } from '../../model/ui/table-row-edit-widget.type';
import StringUtils from './string-utils';
import { Constants } from '../../constants';
import { getCountriesSelectOptions } from '../../model/dto/shipping-rate/countries-select-options';

export const mapShippingRateToTableDataFormat = (
  shippingRate?: ShippingRate
): OvTableData => {
  return [
    {
      label: 'shippingRates.fields.internalName',
      value: shippingRate?.internal_name,
      translateLabel: true,
      editOptions: {
        widgetType: TableRowEditWidgetType.TEXT,
        propertyName: 'internal_name',
        placeholder: i18n.t('shippingRates.fields.internalName'),
      },
    },
    {
      label: 'shippingRates.fields.displayName',
      value: shippingRate?.display_name,
      translateLabel: true,
      editOptions: {
        widgetType: TableRowEditWidgetType.TEXT,
        propertyName: 'display_name',
        placeholder: i18n.t('shippingRates.fields.displayName'),
      },
    },
    {
      label: 'shippingRates.fields.description',
      value: shippingRate?.description,
      translateLabel: true,
      editOptions: {
        widgetType: TableRowEditWidgetType.TEXT,
        propertyName: 'description',
        placeholder: i18n.t('shippingRates.fields.description'),
      },
    },
    {
      label: 'shippingRates.fields.unitAmount',
      value: shippingRate?.unit_amount,
      translateLabel: true,
    },
    {
      label: 'shippingRates.fields.displayPrice',
      value: shippingRate?.display_price,
      translateLabel: true,
    },
    {
      label: 'shippingRates.fields.currency',
      value: shippingRate?.currency,
      translateLabel: true,
    },
    {
      label: 'shippingRates.fields.countries',
      value: shippingRate?.countries,
      translateLabel: true,
      editOptions: {
        options: getCountriesSelectOptions(),
        propertyName: 'countries',
        widgetType: TableRowEditWidgetType.MULTI_SELECT,
      },
    },
    {
      label: 'physicalProducts.fields.stripePriceId',
      value: shippingRate?.stripe_price_id,
      translateLabel: true,
      linkUrl: `https://dashboard.stripe.com/${
        !Constants.IS_PRODUCTION ? 'test/' : ''
      }prices/${shippingRate?.stripe_price_id}`,
    },
    {
      label: 'shippingRates.fields.isActive',
      value: shippingRate?.is_active,
      prettifiedValue: StringUtils.getPrettifiedBooleanValue(
        shippingRate?.is_active
      ),
      translateLabel: true,
      editOptions: {
        propertyName: 'is_active',
        widgetType: TableRowEditWidgetType.BOOLEAN,
      },
    },
    {
      label: 'shippingRates.fields.deliveryEstimateMinimum',
      value: shippingRate?.delivery_estimate.minimum,
      prettifiedValue: shippingRate
        ? `${
            shippingRate?.delivery_estimate.minimum?.value
          } ${getEstimatedDeliveryUnitTranslation(
            shippingRate?.delivery_estimate.minimum?.unit
          )}`
        : '-',
      translateLabel: true,
    },
    {
      label: 'shippingRates.fields.deliveryEstimateMaximum',
      value: shippingRate?.delivery_estimate.maximum,
      prettifiedValue: shippingRate
        ? `${
            shippingRate?.delivery_estimate.maximum?.value
          } ${getEstimatedDeliveryUnitTranslation(
            shippingRate?.delivery_estimate.maximum?.unit
          )}`
        : '-',
      translateLabel: true,
    },
  ];
};

const getEstimatedDeliveryUnitTranslation = (
  unit?:
    | Stripe.ShippingRate.DeliveryEstimate.Maximum.Unit
    | Stripe.ShippingRate.DeliveryEstimate.Minimum.Unit
) => {
  switch (unit) {
    case 'business_day':
      return i18n.t('shippingRates.deliveryEstimateUnits.businessDay');
    case 'day':
      return i18n.t('shippingRates.deliveryEstimateUnits.day');
    case 'week':
      return i18n.t('shippingRates.deliveryEstimateUnits.week');
    case 'month':
      return i18n.t('shippingRates.deliveryEstimateUnits.month');
    case 'hour':
      return i18n.t('shippingRates.deliveryEstimateUnits.hour');
  }
};
